import { APIURL } from "./config";
import axios from "axios";
import { toast } from "react-toastify";
import { REPORTS } from "./type";

export const reportList = () => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(`${APIURL}/api/v1/report`, config);
    dispatch({
      type: REPORTS,
      payload: res.data,
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
